<div class="faq-container" [ngClass]="{ show: show }" (click)="toggle()">
  @if (currentFaqItem) {
    <div class="faq-content" (click)="$event.stopPropagation()">
      <div class="faq-navigation">
        @if (historyStack?.length) {
          <span class="icon-chevron-left" (click)="goBack()"></span>
        }
        <div class="faq-headline" [ngClass]="{ center: historyStack?.length }">
          {{ getHeadline() }}
        </div>
        <span class="icon-close" (click)="toggle()"></span>
      </div>
      <div class="faq-layer">
        <div class="slider" [@slide]="level" @slideTopic>
          @if (visibleItems?.length) {
            <div class="faq-topic-layer" [ngClass]="{ 'with-buttons': !historyStack?.length }">
              <ul>
                @for (item of visibleItems; track item) {
                  <li (click)="selectItem(item)" id="navigation-{{ $index }}">
                    <a>{{ getTitle(item) }}</a>
                  </li>
                }
              </ul>
            </div>
          }
          @if (!visibleItems?.length) {
            <div class="faq-answer-layer">
              <div class="faq-answer-layer-items">
                <div class="faq-answer-layer-items">
                  @if (IS_TRS_PROJECT) {
                    <div class="faq-content">
                      <h4>{{ getTitle(currentFaqItem) }}</h4>
                      <div class="faq-answer-layer-text" [innerHTML]="getContent(currentFaqItem)"></div>
                      @if (currentFaqItem.videoLink) {
                        <div class="video">
                          <video
                            #videoElement
                            class="video-js vjs-default-skin"
                            controls
                            data-setup='{ "aspectRatio":"640:267", "playbackRates": [1, 1.5, 2] }'
                            id="my_video_1"
                            preload="none"
                            width="100%">
                            <source [src]="currentFaqItem.videoLink" />
                          </video>
                        </div>
                      }
                      @if (currentFaqItem.documents) {
                        <div>
                          <app-drop-zone
                            (itemHandler)="handleItem(currentFaqItem, $event)"
                            [(ngModel)]="currentFaqItem.documents"
                            [disabled]="true"
                            [multiple]="true"
                          [readonly]="true"></app-drop-zone>
                        </div>
                      }
                    </div>
                  }
                  @if (IS_PRODUCT_SAFETY_PROJECT) {
                    @if (getTitle(currentFaqItem)) {
                      <div class="faq-content">
                        <h4>{{ getTitle(currentFaqItem) }}</h4>
                        <div class="faq-answer-layer-text" [innerHTML]="getContent(currentFaqItem)"></div>
                        @if (getCurrentLanguage() === 'de') {
                          @if (currentFaqItem.documentsDE) {
                            <div>
                              <app-drop-zone
                                (itemHandler)="handleItem(currentFaqItem, $event, 'de')"
                                [(ngModel)]="currentFaqItem.documentsDE"
                                [disabled]="true"
                                [multiple]="true"
                              [readonly]="true"></app-drop-zone>
                            </div>
                          }
                        } @else {
                          @if (currentFaqItem.documentsEN) {
                            <div>
                              <app-drop-zone
                                (itemHandler)="handleItem(currentFaqItem, $event, 'en')"
                                [(ngModel)]="currentFaqItem.documentsEN"
                                [disabled]="true"
                                [multiple]="true"
                              [readonly]="true"></app-drop-zone>
                            </div>
                          }
                        }
                        @if (currentFaqItem.videoLink) {
                          <div class="video">
                            <video
                              #videoElement
                              class="video-js vjs-default-skin"
                              controls
                              data-setup='{ "aspectRatio":"640:267", "playbackRates": [1, 1.5, 2] }'
                              id="my_video_1"
                              preload="none"
                              width="100%">
                              <source [src]="currentFaqItem.videoLink" />
                            </video>
                          </div>
                        }
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
